import script from "./AdButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdButton.vue?vue&type=script&setup=true&lang=ts"

import "./AdButton.vue?vue&type=style&index=0&id=1df5ceb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df5ceb0"]])

export default __exports__